import { render, staticRenderFns } from "./CompleteOAuthProfileForm.vue?vue&type=template&id=6025a00a&"
import script from "./CompleteOAuthProfileForm.vue?vue&type=script&lang=js&"
export * from "./CompleteOAuthProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6025a00a')) {
      api.createRecord('6025a00a', component.options)
    } else {
      api.reload('6025a00a', component.options)
    }
    module.hot.accept("./CompleteOAuthProfileForm.vue?vue&type=template&id=6025a00a&", function () {
      api.rerender('6025a00a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/CompleteOAuthProfileForm.vue"
export default component.exports